import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
import React, { useEffect, useState } from 'react';
import Page from './page/page';

import { Auth0Provider, useAuth0 } from '@auth0/auth0-react';
import { BrowserRouter, Redirect, Route, Switch, useLocation } from 'react-router-dom';
import { InvitationExpired } from '../components/invitaionExpired/invitationExpired';
import { LoadingSpinner } from '../index';
import { ClientApplication } from '../msal/clientApp';
import ROUTES from '../routes/routes';
import { useSettings } from './../contexts/SettingsContext';
import './app.scss';
import Login from './login/login';
import { Register } from './login/register';
import { PointLogin } from './pointLogin/pointLogin';


const UnauthenticatedFlow: React.FC = () => {
    return (
        <Switch>
            <Route exact path={'/'} component={Login} />
            <Route exact path={ROUTES.CREATE_ACCOUNT.ROUTE} component={Register} />
            <Route exact path={ROUTES.POINT_LOGIN.ROUTE} component={PointLogin} />
            <Route exact path={ROUTES.INVITATION_EXPIRED.ROUTE} component={InvitationExpired} />
            <Route path={ROUTES.ACTIVATE_SUBSCRIPTION_FORM.ROUTE} component={Page} />
            <Redirect to="/" />
        </Switch>
    );
}

const AuthenticatedFlow: React.FC = () => {
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const { settings } = useSettings();

    useEffect(() => {
        async function initializeClient() {
            await ClientApplication.initialize(
                settings?.domain!,
                settings?.clientId!,
                settings?.audience!);
            setIsLoading(false);

        }
        initializeClient();
    }, [settings]);

    return isLoading ? <LoadingSpinner /> : <Page />
}

const AuthenticationInitialization: React.FC<{ children: JSX.Element }> = (props) => {
    const { isLoading } = useAuth0();
    const settings = useSettings();

    const showLoadingSpinner = isLoading || settings.isLoading;

    return (
        <>
            {showLoadingSpinner && <LoadingSpinner />}
            {!showLoadingSpinner &&
                props.children
            }
        </>
    )
}

const AuthenticationBoundary: React.FC = () => {
    const { isAuthenticated } = useAuth0();
    const location = useLocation();

    const isPointLoginRoute = location.pathname === ROUTES.POINT_LOGIN.ROUTE;

    if (isPointLoginRoute) {
        return <PointLogin />;
    }

    return (
        <AuthenticationInitialization >
            <>
                {!isAuthenticated && <UnauthenticatedFlow />}
                {isAuthenticated && <AuthenticatedFlow />}
            </>
        </AuthenticationInitialization>
    )
}

const app = () => {
    const { settings } = useSettings();

    if (!navigator.cookieEnabled) {
        return (
            <div className="cookies-disabled">
                <h1>We can't sign you in</h1>
                <p>Your browser is currently set to block cookies.<b>You need to allow cookies to use this service.</b></p>
                <p>Cookies are small text files stored on your computer that tell us when you're signed in. To learn how to allow cookies, check the online help in your web browser.</p>
            </div>
        );
    }
    return (
        <Auth0Provider
            domain={settings?.domain!}
            clientId={settings?.clientId!}
            authorizationParams={{
                redirect_uri: window.location.origin,
                scope: 'openid profile email',
                audience: settings?.audience!
            }}
            cacheLocation="localstorage"
            useRefreshTokens={true}
            skipRedirectCallback={window.location.pathname === '/activate-subscription'}

        >
            <BrowserRouter>
                <AuthenticationBoundary />
            </BrowserRouter>
        </Auth0Provider>
    )
}

export default app;